import Icons from "./icon"

export type { IconProps } from "./icon"
export default Icons
